export const ERROR_PAGE = 'ERROR_PAGE'
const ONBOARDING_GETTING_STARTED = 'ONBOARDING_GETTING_STARTED'
const ONBOARDING_ABOUT_YOU = 'ONBOARDING_ABOUT_YOU'
const ONBOARDING_PERSONAL_INFORMATION = 'ONBOARDING_PERSONAL_INFORMATION'
const ONBOARDING_IDENTITY_VERIFICATION = 'ONBOARDING_IDENTITY_VERIFICATION'
const ONBOARDING_EMPLOYMENT_DETAILS = 'ONBOARDING_EMPLOYMENT_DETAILS'
const ONBOARDING_YOUR_ACCOUNTS = 'ONBOARDING_YOUR_ACCOUNTS'
const ONBOARDING_ACCOUNT_DETAILS = 'ONBOARDING_ACCOUNT_DETAILS'
const ONBOARDING_EMPLOYER_INFORMATION = 'ONBOARDING_EMPLOYER_INFORMATION'
const ONBOARDING_ADDITIONAL_DETAILS = 'ONBOARDING_ADDITIONAL_DETAILS'
const ONBOARDING_JOINT_OWNER = 'ONBOARDING_JOINT_OWNER'
const ONBOARDING_ADD_CONTACT = 'ONBOARDING_ADD_CONTACT'
const ONBOARDING_EDIT_CONTACT = 'ONBOARDING_EDIT_CONTACT'
const ONBOARDING_CONTACTS_PAGE = 'ONBOARDING_CONTACTS_PAGE'
const ONBOARDING_REVIEW_AND_SUBMIT = 'ONBOARDING_REVIEW_AND_SUBMIT'
const ONBOARDING_CONFIRMATION = 'ONBOARDING_CONFIRMATION'

export default {
  ERROR_PAGE,
  ONBOARDING_GETTING_STARTED,
  ONBOARDING_ABOUT_YOU,
  ONBOARDING_PERSONAL_INFORMATION,
  ONBOARDING_IDENTITY_VERIFICATION,
  ONBOARDING_EMPLOYMENT_DETAILS,
  ONBOARDING_YOUR_ACCOUNTS,
  ONBOARDING_ACCOUNT_DETAILS,
  ONBOARDING_EMPLOYER_INFORMATION,
  ONBOARDING_ADDITIONAL_DETAILS,
  ONBOARDING_JOINT_OWNER,
  ONBOARDING_ADD_CONTACT,
  ONBOARDING_EDIT_CONTACT,
  ONBOARDING_CONTACTS_PAGE,
  ONBOARDING_REVIEW_AND_SUBMIT,
  ONBOARDING_CONFIRMATION
}



// WEBPACK FOOTER //
// ./src/actionTypes/routing.js